import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { AdminListPageLayout } from '../../components/admin-list-page-layout/admin-list-page-layout';
import theme from '../../theme';
import React, { useState } from 'react';
import { DataGrid } from '../../components/data-grid/data-grid';
import { HTTPMethodType } from '../../components/data-grid/data-grid-utils';
import { SubHeader } from '../organizations/subheader';
import { gridOptions } from '../users/user-list-utils';
import { styles } from './external-app-users/external-app.styles';
const endpoint = (orgId)=>{
    const params = [
        [
            'organizationId',
            `${orgId}`
        ]
    ];
    const endPoint = {
        endPoint: `/externalApplication/list/v1`,
        HTTPMethodType: HTTPMethodType.GET,
        params: params
    };
    return endPoint;
};
export const updatedColDefs = (columnDefs)=>{
    const cols = columnDefs.map((col, index)=>{
        let column = {
            ...col,
            headerName: col.displayName,
            field: col.key,
            sortable: false
        };
        // Primary column matches tenants/users: interactive accent for row-click navigation.
        if (index === 0) {
            column.cellStyle = {
                color: theme.colors.accent[200]
            };
        }
        return column;
    });
    return cols;
};
export const ExternalApplicationList = (props)=>{
    const { onSelection, orgId, columnDefs, sortablePageable } = props;
    const classes = styles();
    const [pageSize, setPageSize] = useState(25);
    const handleSelect = (rowData)=>{
        onSelection(rowData.data, window.location.pathname);
    };
    const onPageSizeChange = (pageSize)=>{
        setPageSize(pageSize);
    };
    return /*#__PURE__*/ _jsxs(AdminListPageLayout, {
        children: [
            /*#__PURE__*/ _jsx(SubHeader, {
                title: 'External applications',
                className: classes.text,
                pageSize: pageSize,
                onPageSizeChange: onPageSizeChange
            }),
            /*#__PURE__*/ _jsx(Box, {
                paddingTop: theme.space[16],
                flex: "1 1 0",
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                children: /*#__PURE__*/ _jsx(DataGrid, {
                    serverSideInfiniteScroll: true,
                    columnDefs: updatedColDefs(columnDefs),
                    gridOptions: gridOptions,
                    filterableOptions: sortablePageable.filterableOptions,
                    endpointData: endpoint(orgId),
                    onRowClicked: (item)=>{
                        handleSelect(item);
                    },
                    paginationPageSize: pageSize
                })
            })
        ]
    });
};
